import respond from './utilities/respond'
import at from '../../actionTypes'
import addReport from '../../../dataservices/addReport'

const reportActions = {
	reportSaveBegin: report => respond(at.REPORT_SAVE_BEGIN, { report }),
	reportSaveSuccess: report => respond(at.REPORT_SAVE_SUCCESS, { report }),
	reportSaveFail: (error, report) => respond(at.REPORT_SAVE_FAIL, { error, report }),
	reportSave: dispatch => async (report) => {
		dispatch(reportActions.reportSaveBegin(report))
		try {
			await addReport(report)
			dispatch(reportActions.reportSaveSuccess(report))
		} catch (error) {
			dispatch(reportActions.reportSaveFail(error, report))
		}
	}
}

export default reportActions



// WEBPACK FOOTER //
// ./src/redux/actionCreators/old_actions/reportActions.js